import {ACCOUNT_MODE} from "@core/entities/account/account-modes/enum/account-mode.enum";
import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export class AccountModeChangedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor(
    public readonly modeType: ACCOUNT_MODE,
  ) {
  }
}
